// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  background-size:cover;
  background-repeat:no-repeat;
  min-height:12em;
}
.brand-logo {
  position:relative;
  margin:0 auto;
  padding-top:1em;
  width:20em;
}
.search-form input {color:#222;}
.brand-logo:hover img {
  filter:drop-shadow(0 0 1em #fff);
}
.big .brand-logo {display:inline-block;}
.small .brand-logo {display:block;}
.main {
  background:#000;
}
.main section {
  background-color:#fff;
  min-height:40em;
}
header nav a, footer nav a {
  font-size:1.2em;
  color:#fff;
  padding:0.666em 1.333em;
  margin-right:0.666em;
  text-decoration:none;
  background:rgba(0,0,0,0.7);
  display:inline-block;
}

header nav a:hover {
  background:rgba(0,0,0,1);
}
header nav > ul > li {
  display:inline-block;
  position:relative;
}
header nav ul li ul {
  display:none;
}
header nav ul li ul {
  background:black;
}
header nav ul li:hover ul {
  display:block;
  position:absolute;
  z-index:10;
}

footer {
  min-height:16em;
  background-image:url('footer.jpg');
  background-color:#070707;
  background-size:cover;
  background-repeat:no-repeat;
}
.special-focus {
  background:#fecd04;
  color:#111;
  min-height:2rem;
  padding:2rem;
  text-align:center;
}
.contact {
  color:#fff;
  min-height:10rem;
}

.contact .container > div {
  width:95%;
  margin:2em auto;
  font-size:1.3rem;
}
.submenu {
  background-color:rgba(0,0,0,0.8);
  min-height:10em;
}
.small {
  max-width:40rem;
  margin:0 auto;
  display:block;
  padding-bottom:1rem;
}
.small nav a {
  display:block;
  border-left:2px solid black;
  margin:0.666em 0;
  box-shadow:0 0 3px #fff;
  padding:1em;
}
.small nav a {
  border-left:2px solid black;
}
.small nav a:focus {
  border-left:2px solid white;
  background-color:rgba(255,255,255,0.2);
}
.full-nav {
  text-align:right;
}
.full-nav .search-and-i18n {
  display:inline-block;
}
.big {
  display:none;
}
.mat-form-field-wrapper {
  background:rgba(255,255,255,0.2);
}

.mailchimp .subscribe {
  margin:0 auto;
  display:block;
  padding:2em 0;
  width:80%;
}

footer .submenu > div {
  display:none;
}
.motto {
  background:black;
  margin:1vw auto;
  text-align:center;
  width:90vw;
  padding:1vw;
}
.motto h2 {
  text-transform:uppercase;
  font-size:4vw;
}
.banner {
  padding:2vw;
  text-align:center;
}
.banner > div {
  text-align:center;
  width:13em;
  display:inline-block;
  margin:0 1rem;
}
.banner img {
  position:relative;
  z-index:5;
}
.small .search .search .search {
  margin-top:1.666em;
  width:100%;
}
.banner button {
  width:10em;
}
.banner a:hover img {
  filter:drop-shadow(0 0 1em #fff);
}

.mat-accordion .mat-expansion-panel:last-of-type {
  background:rgba(0,0,0,0.87);
  color:#fff;
  border:1px solid rgba(255,255,255,0.2);
  margin:0 1em;
}
.mat-expansion-indicator::after, .mat-expansion-panel-header-description {
  color:rgba(255,255,255,0.7);
}

.watermark {
  background-repeat:no-repeat;
  background-position:100px 0;
}

.subscribe > div {
  width:100%;
  text-align:center;
  padding-bottom:0.666em;
}
.subscribe > div:nth-child(2) mat-form-field {
  width:100%;
}

footer .container > section {
  width:90vw;
  margin:2em auto;
}

footer .container > section markdown {
  color:#fff;
}

@media only screen and (min-width:50em) {
  footer .container {
    width:80vw;
    margin:0 auto;
  }
  footer .container > section {
    margin: 4em 1%;
    display: inline-block;
    width: 48%;
  }
  .mailchimp .subscribe {
    width:40em;
  }
  .subscribe > div {
    display:inline-block;
  }
  .subscribe > div:first-child {
    width:6em;
    font-size:1.5em;
  }
  .subscribe > div:nth-child(2) {
    width:23em;
    padding-right:1em;
  }
  .subscribe > div:nth-child(2) mat-form-field {
    width:100%;
  }
  .subscribe > div:last-child {
    width:8em;
  }
  .subscribe > div:last-child button {
    width:100%;
  }
  footer .submenu {
    padding-top:3em;
  }
  footer .submenu > div {
    display:block;
  }
  footer nav a {
    display:inline-block;
    margin:0 2em;
  }
  footer nav {
    text-align:center;
  }
  footer nav a:hover {
    border-bottom:1px solid white;
  }
  .contact {
    text-align:center;
  }
  .contact .container > div {
    display:inline-block;
    text-align:left;
    width:13em;
    margin:5em 1em;
  }
  .motto {
    width:42em;
    margin:1em auto;
    padding:1em;
  }
  .motto h2 {
    font-size:2em;
  }
}

@media only screen and (min-width:80em) {
  footer .container > section {
    margin: 4em 1%;
    display: inline-block;
    width: 23%;
  }
  .motto {
    width:65em;
    margin:1em auto;
    padding:1em;
    position:relative;
  }
  .main .content {
    width:55em;
  }
  .motto h2 {
    font-size:3em;
  }
  .big {
    display:flex;
    justify-content:space-between;
  }
  .big .search-and-i18n {
    text-align:right;
    width:25rem;
    margin-top:0.5rem;
  }
  .big .search-form form {
    width:100%;
  }
  .big .search-form form > * {
    width:100%;
  }
  .big .search-form input {
    width:100%;
  }
  .big nav a {
    border-bottom:1px solid transparent;
    margin-bottom:0.2em;
  }
  .big nav a:hover {
    border-bottom:1px solid white;
  }
  .big .brand-logo {
    width:20em;
    top:1em;
  }
  .big .brancd-logo:active {
    top:1.1em;
  }
  .small {display:none;}
}

@media only screen and (min-width:90em) {
  .big .brand-logo {right:4em;}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/basic-page/basic-page.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;AACA,oBAAoB,UAAU,CAAC;AAC/B;EACE,gCAAgC;AAClC;AACA,kBAAkB,oBAAoB,CAAC;AACvC,oBAAoB,aAAa,CAAC;AAClC;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kCAAsD;EACtD,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;IACV,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,UAAU;IACV,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,OAAO;EACT;EACA;IACE,SAAS;EACX;EACA,QAAQ,YAAY,CAAC;AACvB;;AAEA;EACE,kBAAkB,SAAS,CAAC;AAC9B","sourcesContent":["header {\n  background-size:cover;\n  background-repeat:no-repeat;\n  min-height:12em;\n}\n.brand-logo {\n  position:relative;\n  margin:0 auto;\n  padding-top:1em;\n  width:20em;\n}\n.search-form input {color:#222;}\n.brand-logo:hover img {\n  filter:drop-shadow(0 0 1em #fff);\n}\n.big .brand-logo {display:inline-block;}\n.small .brand-logo {display:block;}\n.main {\n  background:#000;\n}\n.main section {\n  background-color:#fff;\n  min-height:40em;\n}\nheader nav a, footer nav a {\n  font-size:1.2em;\n  color:#fff;\n  padding:0.666em 1.333em;\n  margin-right:0.666em;\n  text-decoration:none;\n  background:rgba(0,0,0,0.7);\n  display:inline-block;\n}\n\nheader nav a:hover {\n  background:rgba(0,0,0,1);\n}\nheader nav > ul > li {\n  display:inline-block;\n  position:relative;\n}\nheader nav ul li ul {\n  display:none;\n}\nheader nav ul li ul {\n  background:black;\n}\nheader nav ul li:hover ul {\n  display:block;\n  position:absolute;\n  z-index:10;\n}\n\nfooter {\n  min-height:16em;\n  background-image:url('../../../assets/img/footer.jpg');\n  background-color:#070707;\n  background-size:cover;\n  background-repeat:no-repeat;\n}\n.special-focus {\n  background:#fecd04;\n  color:#111;\n  min-height:2rem;\n  padding:2rem;\n  text-align:center;\n}\n.contact {\n  color:#fff;\n  min-height:10rem;\n}\n\n.contact .container > div {\n  width:95%;\n  margin:2em auto;\n  font-size:1.3rem;\n}\n.submenu {\n  background-color:rgba(0,0,0,0.8);\n  min-height:10em;\n}\n.small {\n  max-width:40rem;\n  margin:0 auto;\n  display:block;\n  padding-bottom:1rem;\n}\n.small nav a {\n  display:block;\n  border-left:2px solid black;\n  margin:0.666em 0;\n  box-shadow:0 0 3px #fff;\n  padding:1em;\n}\n.small nav a {\n  border-left:2px solid black;\n}\n.small nav a:focus {\n  border-left:2px solid white;\n  background-color:rgba(255,255,255,0.2);\n}\n.full-nav {\n  text-align:right;\n}\n.full-nav .search-and-i18n {\n  display:inline-block;\n}\n.big {\n  display:none;\n}\n.mat-form-field-wrapper {\n  background:rgba(255,255,255,0.2);\n}\n\n.mailchimp .subscribe {\n  margin:0 auto;\n  display:block;\n  padding:2em 0;\n  width:80%;\n}\n\nfooter .submenu > div {\n  display:none;\n}\n.motto {\n  background:black;\n  margin:1vw auto;\n  text-align:center;\n  width:90vw;\n  padding:1vw;\n}\n.motto h2 {\n  text-transform:uppercase;\n  font-size:4vw;\n}\n.banner {\n  padding:2vw;\n  text-align:center;\n}\n.banner > div {\n  text-align:center;\n  width:13em;\n  display:inline-block;\n  margin:0 1rem;\n}\n.banner img {\n  position:relative;\n  z-index:5;\n}\n.small .search .search .search {\n  margin-top:1.666em;\n  width:100%;\n}\n.banner button {\n  width:10em;\n}\n.banner a:hover img {\n  filter:drop-shadow(0 0 1em #fff);\n}\n\n.mat-accordion .mat-expansion-panel:last-of-type {\n  background:rgba(0,0,0,0.87);\n  color:#fff;\n  border:1px solid rgba(255,255,255,0.2);\n  margin:0 1em;\n}\n.mat-expansion-indicator::after, .mat-expansion-panel-header-description {\n  color:rgba(255,255,255,0.7);\n}\n\n.watermark {\n  background-repeat:no-repeat;\n  background-position:100px 0;\n}\n\n.subscribe > div {\n  width:100%;\n  text-align:center;\n  padding-bottom:0.666em;\n}\n.subscribe > div:nth-child(2) mat-form-field {\n  width:100%;\n}\n\nfooter .container > section {\n  width:90vw;\n  margin:2em auto;\n}\n\nfooter .container > section markdown {\n  color:#fff;\n}\n\n@media only screen and (min-width:50em) {\n  footer .container {\n    width:80vw;\n    margin:0 auto;\n  }\n  footer .container > section {\n    margin: 4em 1%;\n    display: inline-block;\n    width: 48%;\n  }\n  .mailchimp .subscribe {\n    width:40em;\n  }\n  .subscribe > div {\n    display:inline-block;\n  }\n  .subscribe > div:first-child {\n    width:6em;\n    font-size:1.5em;\n  }\n  .subscribe > div:nth-child(2) {\n    width:23em;\n    padding-right:1em;\n  }\n  .subscribe > div:nth-child(2) mat-form-field {\n    width:100%;\n  }\n  .subscribe > div:last-child {\n    width:8em;\n  }\n  .subscribe > div:last-child button {\n    width:100%;\n  }\n  footer .submenu {\n    padding-top:3em;\n  }\n  footer .submenu > div {\n    display:block;\n  }\n  footer nav a {\n    display:inline-block;\n    margin:0 2em;\n  }\n  footer nav {\n    text-align:center;\n  }\n  footer nav a:hover {\n    border-bottom:1px solid white;\n  }\n  .contact {\n    text-align:center;\n  }\n  .contact .container > div {\n    display:inline-block;\n    text-align:left;\n    width:13em;\n    margin:5em 1em;\n  }\n  .motto {\n    width:42em;\n    margin:1em auto;\n    padding:1em;\n  }\n  .motto h2 {\n    font-size:2em;\n  }\n}\n\n@media only screen and (min-width:80em) {\n  footer .container > section {\n    margin: 4em 1%;\n    display: inline-block;\n    width: 23%;\n  }\n  .motto {\n    width:65em;\n    margin:1em auto;\n    padding:1em;\n    position:relative;\n  }\n  .main .content {\n    width:55em;\n  }\n  .motto h2 {\n    font-size:3em;\n  }\n  .big {\n    display:flex;\n    justify-content:space-between;\n  }\n  .big .search-and-i18n {\n    text-align:right;\n    width:25rem;\n    margin-top:0.5rem;\n  }\n  .big .search-form form {\n    width:100%;\n  }\n  .big .search-form form > * {\n    width:100%;\n  }\n  .big .search-form input {\n    width:100%;\n  }\n  .big nav a {\n    border-bottom:1px solid transparent;\n    margin-bottom:0.2em;\n  }\n  .big nav a:hover {\n    border-bottom:1px solid white;\n  }\n  .big .brand-logo {\n    width:20em;\n    top:1em;\n  }\n  .big .brancd-logo:active {\n    top:1.1em;\n  }\n  .small {display:none;}\n}\n\n@media only screen and (min-width:90em) {\n  .big .brand-logo {right:4em;}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
